import moment from 'moment';

export class Matcher {

    constructor(public regex: any = /\<([a-zA-Z0-9_-]+)\>/g) {
        this.regex = regex;
    }

    match(pattern: any, types: any, input: any) {
        const result = {};
        pattern = pattern.split(/\s+/g);
        types = types.split(/\s+/g);

        if ( pattern.length !== types.length ) {
            return { error: 'ERROR: Pattern length and types length must match.' };
        }

        // Process input
        input = input.replace(/'/g, '"');
        let query: any = this.extractText(input);
        input = input.replace('"' + query + '" ', '');
        input = input.split(/\s+/g);
        if ((input && input.length > 0) && (query && query.length > 0)) {
            input.unshift(query);
        }
        pattern.forEach((roman, i) => {
            if (this.regex.test(roman)) {
                const key = roman.replace(this.regex, '$1');
                if ( input[i] ) {
                    if ( types[i] === 'order' ) {
                        if ( input[i].toLowerCase() === 'asc' || input[i].toLowerCase() === 'desc' ) {
                            result[key] = input[i].toLowerCase();
                        } else {
                            result[key] = 'desc';
                        }
                    } else if ( types[i] === 'date' ) {
                        //console.log('forEach', input[i], moment(input[i], "DD/MM/YYYY"), moment(input[i], "DD/MM/YYYY").isValid(), moment(input[i], "DD/MM/YYYY").unix());
                        result[key] = moment(input[i], "DD/MM/YYYY").isValid() ? moment(input[i], "DD/MM/YYYY").unix():undefined;
                    } else if ( types[i] === 'number' ) {
                        result[key] = parseInt(input[i]);
                    } else {
                        result[key] = input[i];
                    }
                }
            }
        });

        //console.log('BEFORE', JSON.stringify(result));
        let i: number = 0;
        for (var key in result) {
            //console.log('key:', key, '| value:', result[key], '| typeof:', typeof result[key], '| type:', types[i], '| isValid:', moment(result[key], "X").isValid() );
            if ( types[i] === 'date' && !moment(result[key], "X").isValid() ) {
                delete result[key];
            } else if ( types[i] !== 'date' && types[i] !== 'order' && typeof result[key] !== types[i] ) {
                delete result[key];
            }
            i++;
        }
        return result;
    }

    extractText(str: string) {
        var ret = "";
        if (/"/.test(str)) {
            let tmp: any = str.match(/"(.*?)"/);
            if (tmp && tmp.length > 0) {
                ret = tmp[1];
            }
        } else {
            ret = str;
        }
        return ret;
    }
}


// WEBPACK FOOTER //
// ./src/utils/matcher.ts